import React from 'react';
import PageTransition from './src/components/PageTransition'; // Ajuste o caminho conforme a sua estrutura de pastas

import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-tooltip/dist/react-tooltip.css'
import './src/styles/global.scss'

export const wrapPageElement = ({ element, props }) => {
    return <PageTransition location={props.location}>{element}</PageTransition>;
};

export const onRouteUpdate = ({ location, prevLocation }) => {
    console.log('>>> onRouteUpdate CHAMADO <<<');
    // Atraso curto para garantir que o DOM e o document.title foram atualizados pelo React
    setTimeout(() => {
        // 1. Verificar se o Data Layer existe (garantindo que o GTM carregou)
        if (typeof window.dataLayer !== 'undefined') {

            const novoTitulo = document.title;
            const urlAtualCompleta = location.href;
            const urlAntigaInterna = prevLocation ? prevLocation.href : '';
            const referrerExterno = document.referrer;
            // 2. DISPARAR O EVENTO CUSTOMIZADO NO DATA LAYER
            console.log({                
                event: 'gatsby_page_view',
                page_path: location.pathname,
                page_title: novoTitulo,
                page_location: urlAtualCompleta, // IMPORTANTE: Contém as UTMs como visto no seu print
                previous_page_location: urlAntigaInterna, // Mostra o caminho dentro do seu site
                external_referrer: referrerExterno,
            });
        }
    }, 50)
}